// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"497":"94197f10","518":"2c2cd364"}[chunkId] + ".css";
};